import { Control, Controller } from 'react-hook-form';
import { dateRegex, validateBirthday } from './helpers';
import { ErrorText, TextInput } from '@buoyhealth/common.buoy-input';
import FormLabel from '../FormLabel';

interface IBirthdayInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  control: Control<any, any>;
  name: string;
  label: string;
  hideTooltip?: boolean;
}

const BirthdayInput = ({
  control,
  name,
  label,
  required,
  hideTooltip,
  ...rest
}: IBirthdayInputProps) => {
  return (
    <Controller
      control={control}
      name={name}
      render={({ field, fieldState }) => {
        const { ref: inputRef, ...fieldProps } = field;
        return (
          <div>
            <FormLabel
              name={name}
              label={label}
              tooltipText={hideTooltip ? '' : 'You must be at least 13-years-old to use Buoy'}
            />
            <TextInput
              {...fieldProps}
              InputLabelProps={{
                htmlFor: 'birthday-input',
                className: 'bp-text-base',
              }}
              InputProps={{
                inputProps: {
                  'data-testid': 'birthday-input',
                  className: '!bp-placeholder-gray-70',
                  ...rest,
                },
                sx: { backgroundColor: 'white' },
              }}
              autoComplete="bday"
              error={fieldState.invalid}
              id="birthday-input"
              inputRef={inputRef}
              placeholder="MM/DD/YYYY"
              type="date"
            />
            <ErrorText show={!!fieldState.error} message="Enter a valid birth date (MM/DD/YYYY)" />
          </div>
        );
      }}
      rules={{
        pattern: {
          value: dateRegex,
          message: 'Invalid date format. Format should match mm/dd/yyyy',
        },
        validate: required ? validateBirthday : undefined,
      }}
    />
  );
};

export default BirthdayInput;
